import { get, post } from "./api";
import type {
  AssessResponse,
  ExtractResponse,
  ExtractTextResponse,
  ExtractionStatusResponse,
} from "../types/extraction";
import { EXTRACTION_TIMEOUT_MS } from "../constants/extraction";

export async function assessRoster(
  imageUrls: string[],
  uploadType?: string,
  signal?: AbortSignal
): Promise<AssessResponse> {
  return post<AssessResponse>(
    "/api/extractions/assess",
    { imageUrls, uploadType },
    { timeout: EXTRACTION_TIMEOUT_MS, signal }
  );
}

export async function extractRoster(
  extractionId: string,
  imageUrls: string[],
  signal?: AbortSignal
): Promise<ExtractResponse> {
  return post<ExtractResponse>(
    "/api/extractions/extract",
    {
      extractionId,
      imageUrls,
    },
    { timeout: EXTRACTION_TIMEOUT_MS, signal }
  );
}

export async function extractTextRoster(
  imageUrls: string[],
  uploadType?: string,
  signal?: AbortSignal
): Promise<ExtractTextResponse> {
  return post<ExtractTextResponse>(
    "/api/extractions/extract-text",
    { imageUrls, uploadType },
    { timeout: EXTRACTION_TIMEOUT_MS, signal }
  );
}

export async function startExtraction(
  imageUrls: string[],
  uploadType?: string,
  signal?: AbortSignal
): Promise<ExtractionStatusResponse> {
  return post<ExtractionStatusResponse>(
    "/api/extractions/start",
    { imageUrls, uploadType },
    { signal }
  );
}

export async function getExtractionStatus(
  extractionId: string,
  signal?: AbortSignal
): Promise<ExtractionStatusResponse> {
  return get<ExtractionStatusResponse>(
    `/api/extractions/${extractionId}/status`,
    { signal }
  );
}
